import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  className?: string;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  className = '',
  ...props
}) => {
  return <a {...props} className={`
        inline-flex items-center justify-center
        bg-accent text-paper font-sans font-semibold tracking-wide
        px-8 py-4 rounded-sm
        transition-all duration-300 ease-out
        hover:bg-ink hover:-translate-y-1 hover:shadow-lg
        active:translate-y-0 active:shadow-md
        text-center
        ${className}
      `} data-id="element-180">
      {children}
    </a>;
};